// extracted by mini-css-extract-plugin
module.exports = {"container":"N","error":"O","disabled":"P","submit":"Q","option":"R","success":"S","failure":"T"};